import { render, staticRenderFns } from "./ButtonEditorMenu.vue?vue&type=template&id=58f67690&scoped=true&lang=pug&"
import script from "./ButtonEditorMenu.vue?vue&type=script&lang=ts&"
export * from "./ButtonEditorMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonEditorMenu.vue?vue&type=style&index=0&id=58f67690&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f67690",
  null
  
)

export default component.exports